"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledGleam = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _GleamMixin = require("../../mixins/components/GleamMixin");
var StyledGleam = /*#__PURE__*/_styledComponents.default.span.withConfig({
  displayName: "StyledGleam",
  componentId: "c11n-8-107-0__sc-wil507-0"
})(["", ""], _GleamMixin.GleamMixin);
exports.StyledGleam = StyledGleam;